import { useQuery } from "react-query";
import SchemaService from "../api/services/SchemaService";
import { deleteKeysIfNestedMatches } from "../components/forms/FormBondApp.helpers";
import { UI_SCHEMA_ELEMS_TO_DELETE } from "../components/forms/FormBondApp.constants";

export const useGetBondAgencyQuestionsSchema = (queryKey: string) => {
  const { data, isLoading, refetch, isError, error } = useQuery(
    queryKey,
    async () => await SchemaService.getBondAgencyQuestionsSchema()
  );

  if (data?.data?.ui_schema) {
    deleteKeysIfNestedMatches(data.data.ui_schema, UI_SCHEMA_ELEMS_TO_DELETE);
  }

  return {
    bondAgencyQuestionsSchema: data?.data?.schema,
    bondAgencyQuestionsUISchema: data?.data?.ui_schema,
    isBondAgencyQuestionsSchemaLoading: isLoading,
    bondAgencyQuestionsSchemaError: error,
    isBondAgencyQuestionsSchemaError: isError,
    fetchBondAgencyQuestionsSchema: refetch,
  };
};
